import { createRoot } from "react-dom/client";
import { useEffect, useState } from "@wordpress/element";
import Filters from "./Filters";
import JobsList from "./JobsList";

import "./editor.scss";
import Pagination from "../components/Pagination.component";
import Constants from "../constants";
import LoadingIcon from "../components/LoadingIcon.component";
import BSHelper from "../BSHelper";

export default function View() {
	const rootElement = document.getElementById("jobsListRoot");
	const entityCode = rootElement.getAttribute("data-entityCode");
	const dataAttributes = JSON.parse(
		rootElement.getAttribute("data-attributes"),
	);
	const jobTypesApiUrl = `${BSHelper.getApiRootUrl()}${
		Constants.APIS.JOBS.TYPES
	}`;
	const experienceLevelsApiUrl = `${BSHelper.getApiRootUrl()}${
		Constants.APIS.JOBS.EXPERIENCE_LEVELS
	}`;

	const [jobs, setJobs] = useState([]);
	const [jobTypes, setJobTypes] = useState("");
	const [experienceLevels, setExperienceLevels] = useState("");
	const [pageIndex, setPageIndex] = useState(1);
	const [pageSize] = useState(dataAttributes.itemsPerPage);
	const [totalPages, setTotalPages] = useState(0);
	const [error, setError] = useState(false);
	const [loading, setLoading] = useState(false);

	const [filtersData, setFiltersData] = useState({
		Keyword: "",
		SortBy: "",
		JobType: "",
		ExperienceLevel: "",
		MinSalary: "0",
		MaxSalary: "1000000",
		Currency: "",
		SortOrder: "",
	});

	useEffect(() => {
		fetchJobTypes();
		fetchExperienceLevels();
	}, []);

	useEffect(() => {
		setTimeout(() => {
			fetchJobs();
		}, 1500);
	}, [pageIndex, filtersData.SortBy, filtersData.Keyword]);

	const fetchJobTypes = async () => {
		try {
			// console.log(`Fetching JobTypes for page ${page}`);

			// Make the API request using the provided URL
			const response = await fetch(jobTypesApiUrl, {
				method: "GET", // GET method for fetching data
				headers: {
					"Accept-Language": document.documentElement.lang, // Use the defined language variable
				},
			});

			// Check if the response is OK (status code 2xx)
			if (!response.ok) {
				throw new Error(`Error: ${response.status}`);
			}

			// Parse the response data
			const data = await response.json();
			// console.log("API Response:", data.data);

			// Check if the data contains the necessary attributes before setting state
			if (data.data && data.data.length > 0) {
				setJobTypes(data.data);
			} else {
				throw new Error("Unexpected API response structure");
			}
		} catch (error) {
			console.error("Error fetching JobTypes:", error);
			setError(error.message || "An unexpected error occurred"); // Set the error state
		} finally {
			setLoading(false); // Stop loading state
		}
	};

	const fetchExperienceLevels = async () => {
		try {
			// console.log(`Fetching ExperienceLevels for page ${page}`);

			// Make the API request using the provided URL
			const response = await fetch(experienceLevelsApiUrl, {
				method: "GET", // GET method for fetching data
				headers: {
					"Accept-Language": document.documentElement.lang, // Use the defined language variable
				},
			});

			// Check if the response is OK (status code 2xx)
			if (!response.ok) {
				throw new Error(`Error: ${response.status}`);
			}

			// Parse the response data
			const data = await response.json();
			// console.log("API Response:", data.data);

			// Check if the data contains the necessary attributes before setting state
			if (data.data && data.data.length > 0) {
				const transformedData = data.data.map((level) => ({
					id: level.id,
					name: level.name,
					nameAr:
						level.name === "Junior"
							? "مبتدئ"
							: level.name === "Mid-Level"
							? "متوسط"
							: level.name === "Senior"
							? "خبير"
							: level.name,
				}));
				setExperienceLevels(transformedData);
			} else {
				throw new Error("Unexpected API response structure");
			}
		} catch (error) {
			console.error("Error fetching ExperienceLevels:", error);
			setError(error.message || "An unexpected error occurred"); // Set the error state
		} finally {
			setLoading(false); // Stop loading state
		}
	};

	const fetchJobs = async () => {
		await BSHelper.fetchJobsList(filtersData, pageIndex, pageSize, entityCode, {
			setLoading,
			setError,
			setJobs,
			setTotalPages,
			setPageIndex,
		});
	};

	const handlePageChange = (page) => {
		setPageIndex(page);
	};

	return (
		<div className="job-list-frontend">
			<div className="flex flex-row items-center justify-between">
				{dataAttributes.showSectionTitle && (
					<h3 className="text-xl font-bold pe-5 text-start lg:text-center lg:text-3xl text-body">
						{dataAttributes.sectionTitle}
					</h3>
				)}

				{dataAttributes.showSectionButton && (
					<a
						href={dataAttributes.sectionButtonUrl}
						target={dataAttributes.sectionButtonTarget}
						className={
							dataAttributes.sectionButtonStyleClasses +
							" !mt-0 " +
							dataAttributes.sectionButtonRoundedStyle
						}
					>
						{dataAttributes.sectionButtonTitle}
					</a>
				)}
			</div>

			{dataAttributes.showSectionFilters && (
				<Filters
					filtersData={filtersData}
					setFiltersData={setFiltersData}
					jobTypes={jobTypes}
					experienceLevels={experienceLevels}
					onApplyFilters={fetchJobs}
					phrases={bseitEditorVars.phrases}
				/>
			)}

			{loading && <LoadingIcon />}

			{/* {error && <ErrorMessage message={error} />} */}

			{!loading && (
				<div className="py-5">
					<JobsList jobs={jobs} phrases={bseitEditorVars.phrases} />
				</div>
			)}

			{!loading && dataAttributes.showSectionPagination && totalPages > 1 && (
				<Pagination
					currentPage={pageIndex}
					totalPages={totalPages}
					onPageChange={handlePageChange}
				/>
			)}
		</div>
	);
}

const root = createRoot(document.getElementById("jobsListRoot"));
root.render(<View />);
